import type { SVGProps } from 'react';

const SvgNavigationSegmentation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Navigation Segmentation"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M17.99 2.02c7.35 0 13.31 5.96 13.31 13.31 0 6.9-5.25 12.58-11.98 13.25 0-.94-.16-1.82-.42-2.63 5.46-.46 9.74-5.04 9.74-10.61 0-1.24-.21-2.43-.6-3.54l-9.45 4.73c-.41.21-.9.18-1.3-.06a1.33 1.33 0 0 1-.63-1.13V4.77c-3.38.42-6.26 2.42-7.89 5.24h-.09c-1.12 0-2.18.23-3.15.64 1.89-5.04 6.76-8.63 12.46-8.63m1.34 2.75v8.41l7.53-3.76a10.64 10.64 0 0 0-7.53-4.65"
    />
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M3.35 18c0-2.94 2.38-5.33 5.33-5.33s5.33 2.38 5.33 5.33c0 1.86-.96 3.51-2.41 4.46 2.86.93 5.07 3.22 5.07 6.19v1.33H.69v-1.33c0-2.98 2.21-5.26 5.07-6.19A5.32 5.32 0 0 1 3.35 18m5.33-2.67c-1.47 0-2.66 1.19-2.66 2.66s1.19 2.66 2.66 2.66 2.66-1.19 2.66-2.66-1.19-2.66-2.66-2.66m0 9.32c2.49 0 4.3 1.22 5.01 2.66H3.67c.7-1.45 2.51-2.66 5.01-2.66"
    />
  </svg>
);

export default SvgNavigationSegmentation;
